import BaseClient from '@/app/model/api/response/baseApiClient'

class FieldOrderModalApi extends BaseClient {
  public getFieldOrderData (order: string, sort: string) {
    const path = '/v1/field/order'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({ type: 'modal' })

    // 並び替え
    if (order !== '') {
      params.append('order_name', order)
      params.append('sort', sort)
    }

    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new FieldOrderModalApi()
